import { render, staticRenderFns } from "./DashboardPdfViewer.vue?vue&type=template&id=bb151a78"
import script from "./DashboardPdfViewer.vue?vue&type=script&lang=js"
export * from "./DashboardPdfViewer.vue?vue&type=script&lang=js"
import style0 from "./DashboardPdfViewer.vue?vue&type=style&index=0&id=bb151a78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports